const SMALL_BREAKPOINT = 500;
const MEDIUM_BREAKPOINT = 768;

export const color = {
  gray20: '#D3D3D3',
  gray40: `#B2B2B2`,
  gray80: '#505050',
  gray100: '#1A1A1A',
  teal20: '#B8E6E4',
  coral80: '#EF4056',
  white100: '#FFFFFF',
  mint100: '#397C5B',
  amber100: '#FCB643',

  // Tracking these here, so at least we can see them all in one place
  // for a better refactor later on.
  // Please check w design that there's no existing alias before adding.
  oneoff: {
    pocketHitsSubmitHover: '#C12342'
  }
};

export const breakpoint = {
  atSmallWidth: `@media (max-width: ${SMALL_BREAKPOINT}px)`,
  atMediumWidth: `@media (max-width: ${MEDIUM_BREAKPOINT}px)`,

  oneOff: {
    pocketHitsConfirmLandingSmall: `@media (max-width: 440px)`,
    pocketHitsConfirmLandingLarge: `@media (min-width: 1000px)`,
  }
};

export const font = {
  DOYLE: `"Doyle", Helvetica, Arial, sans-serif`,
  GRAPHIK: `"Graphik Web", "Helvetica Neue", Helvetica, Arial, sans-serif`,
}

export const socialLinks = {
  facebook: "https://www.facebook.com/pocket",
  twitter: "https://twitter.com/Pocket",
  linkedin: "https://www.linkedin.com/company/pocket-formerly-read-it-later-/",
}

export default {
  socialUtmCodes: {
    "FB": "fbsynd",
    "TWITTER": "twtrsynd",
    "EMAIL": "emailsynd",
  },
}
